export default __webpack_public_path__ + "static/media/single-check.d5ef51fb.svg";